import './Header.css';


export function Header() {
    return <header className="header"> <img src="/img/header.png" alt="org" /> </header>
}

